export default function Approach() {
  const steps = [
    {
      number: '01',
      title: 'Discovery &amp; Strategic Alignment',
      description: 'We evaluate workflows, risk exposure, and growth objectives.'
    },
    {
      number: '02',
      title: 'System Architecture Design',
      description: 'We design AI-enabled systems aligned with compliance and operational structure.'
    },
    {
      number: '03',
      title: 'Implementation &amp; Optimization',
      description: 'We deploy, test, refine, and measure performance.'
    },
    {
      number: '04',
      title: 'Continuous Guidance',
      description: 'AI is not a one-time install. We provide long-term strategic direction.'
    }
  ];

  return (
    <section id="approach" className="py-36 bg-slate-900">
      <div className="max-w-[1400px] mx-auto px-20">
        <h2 className="text-5xl font-semibold text-white text-center mb-20">
          A Structured Path to Intelligent Transformation
        </h2>

        <div className="relative">
          <div className="absolute top-16 left-0 right-0 h-0.5 bg-white/20"></div>

          <div className="grid grid-cols-4 gap-16 relative">
            {steps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-8 relative z-10">
                  <span className="text-white text-xl font-bold">{step.number}</span>
                </div>
                <h3 className="text-xl font-semibold text-white mb-4">
                  {step.title}
                </h3>
                <p className="text-base text-slate-300 leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
